
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import { SolarDataLayer } from "../../shared/SolarDataLayer";

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop({ required: true }) readonly dataSource: string;
  @Prop() readonly imageBaseUrl: string;
  @Prop({ default: 6 }) private chunkSize: number;
  @Prop({ default: () => [] }) private wishlistItems: Array<object>;

  protected searchQuery: string = '';

  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private get dataLayerProducts(): Array<object> {
    const products = [...this.products];

    return products.map((product: object) => {
      return {
        ...product,
        'item_id': product['product_id'],
        'item_group_id': product['pim_productfamilie'] || product['product_id'],
        'item_variant': '',
        'item_variant_id': product['product_id'],
      };
    });
  }

  @Watch('products')
  private handleProductListDataLayer(nv, ov): void {
    if(nv !== ov) {
      SolarDataLayer.init().addViewItemsList(this.dataLayerProducts, 'Product list');
    }
  }

  private get productChunks(): Array<object> {
    return Array.from({ length: Math.ceil(this.products.length / this.chunkSize) }, (v, i) => this.products.slice(i * this.chunkSize, i * this.chunkSize + this.chunkSize));
  }

  private created(): void {
    SolarDataLayer.init().addViewItemsList(this.dataLayerProducts, 'Product list');
  }

  private updated(): void {
    const searchParams = new URLSearchParams(window.location.search);
    this.searchQuery = searchParams.get('query');
  }

  private mounted(): void {
    const searchParams = new URLSearchParams(window.location.search);
    this.searchQuery = searchParams.get('query');
  }
}
